import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { getActiveCropId } from 'current/currentSelectors';

import SearchSeedProductsTrigger from 'edit/seed-product-selector/SearchSeedProductsTrigger';
import SeedProductSelectorBrand from 'edit/seed-product-selector/SeedProductSelectorBrand';
import SeedProductSelectorRm from 'edit/seed-product-selector/SeedProductSelectorRm';
import WinfieldLink from 'edit/seed-product-selector/WinfieldLink';
import { getCropBasedMessage } from 'util/locale';

const baseString = 'vra-seed-product-selector-search-form';
const classString = classNames({
  [`${baseString}`]: true
});
const SeedProductSearchForm = ({
  brands,
  isAppMode,
  onChangeBrand,
  onChangeRm,
  onClickSearchSeedProductsTrigger,
  onClickWinfieldLink,
  rmValues,
  searchParams,
  shouldShowWinfieldLink,
  hasDefinedRmRange,
  validationResult
}) => {
  const { brandsValidationResult, isInvalid, rmValuesValidationResult } = validationResult;
  const cropId = useSelector(getActiveCropId);

  return (
    <form className={classString}>
      <legend className={`${baseString}__legend`}>
        {getCropBasedMessage({ key:'title-text__seed-finder-form', cropId })}
      </legend>
      <section className={`${baseString}__body`}>
        <SeedProductSelectorRm
          onChangeRm={onChangeRm}
          rmValues={rmValues}
          searchParams={searchParams}
          useDropdowns={hasDefinedRmRange}
          validationResult={rmValuesValidationResult}
        />
        <SeedProductSelectorBrand
          autoBlur={true}
          brands={brands}
          isAppMode={isAppMode}
          onChange={onChangeBrand}
          searchParams={searchParams}
          validationResult={brandsValidationResult}
        />
        <WinfieldLink
          isVisible={shouldShowWinfieldLink}
          onClickWinfieldLink={onClickWinfieldLink}
        />
      </section>
      <footer className={`${baseString}__footer`}>
        <SearchSeedProductsTrigger
          data-test-id={baseString}
          isDisabled={isInvalid}
          onClickSearchSeedProductsTrigger={onClickSearchSeedProductsTrigger}
        />
      </footer>
    </form>
  );
};

SeedProductSearchForm.propTypes = {
  brands: propTypes.array.isRequired,
  hasDefinedRmRange: propTypes.bool.isRequired,
  isAppMode: propTypes.bool.isRequired,
  onChangeBrand: propTypes.func.isRequired,
  onChangeRm: propTypes.func.isRequired,
  onClickSearchSeedProductsTrigger: propTypes.func.isRequired,
  onClickWinfieldLink: propTypes.func.isRequired,
  rmValues: propTypes.array.isRequired,
  searchFormIsValid: propTypes.bool.isRequired,
  searchParams: propTypes.object.isRequired,
  seedProductSelectorvalidationResult: propTypes.object,
  shouldShowWinfieldLink: propTypes.bool.isRequired,
  validationResult: propTypes.object
};
export default SeedProductSearchForm;
